import { useDispatch, useSelector } from "react-redux";
import "./Stock.css";
import ImmoHeader from "../../componnents/ImmoHeader";
import ListeLots from "../../componnents/ListeLots";
import ListeProgrammes from "../../componnents/ListeProgrammes";
import ListeCarte from "../../componnents/ListeCarte";
import {
  setActiveView,
  fetchLots,
  fetchProgrammes,
} from "../../../../redux/actions/immobilierActions";
import Pagination from "../../../../components/commons/Pagination";
import { useEffect, useState } from "react";
import AddProperty from "./components/AddProperty";
import { openModal } from "../../../../redux/actions/modalActions";
import AddProgramme from "./components/AddProgramme";

const Stock = ({
  listeDesProgrammes,
  programmesPagination,
  programmeListMapPagination,
  programmeListMap,
  programmesCoordinates,
  ongletType,
  ongletId,
  ongletName,
  query,
  listesLots,
  loading,
  lotsLoading,
  lotsError,
  lotsPagination,
  changedOnglet,
}) => {
  const dispatch = useDispatch();

  const { activeView } = useSelector((state) => state.immobilierReducer);

  const [filterInput, setFilterInput] = useState("");
  const [sortConfigProgrammes, setSortConfigProgrammes] = useState({
    key: null,
    direction: "desc",
  });
  const [sortConfigLots, setSortConfigLots] = useState({
    key: null,
    direction: "desc",
  });

  // Real-time search effect
  useEffect(() => {
    // Skip if filterInput is undefined or if we're still loading
    if (filterInput === undefined || loading) return;

    // Trigger search based on active view
    if (activeView === "lots") {
      dispatch(
        fetchLots(
          {
            ...query,
            search: filterInput,
            page: 1, // Reset to first page on new search
            sort: sortConfigLots.key,
            direction: sortConfigLots.direction,
          },
          ongletType,
          ongletId
        )
      );
    } else if (activeView === "programmes" || activeView === "carte") {
      dispatch(
        fetchProgrammes(
          {
            ...query,
            search: filterInput,
            page: 1, // Reset to first page on new search
            sort: sortConfigProgrammes.key,
            direction: sortConfigProgrammes.direction,
          },
          ongletType,
          ongletId
        )
      );
    }
  }, [filterInput]); // Trigger when filterInput or activeView changes

  const handleLotsPageChange = (page) => {
    dispatch(
      fetchLots(
        {
          ...query,
          search: filterInput,
          page: page,
          sort: sortConfigLots.key,
          direction: sortConfigLots.direction,
        },
        ongletType,
        ongletId
      )
    );
  };

  const handleProgramPageChange = (page) => {
    dispatch(
      fetchProgrammes(
        {
          ...query,
          search: filterInput,
          page: page,
          sort: sortConfigProgrammes.key,
          direction: sortConfigProgrammes.direction,
        },
        ongletType,
        ongletId
      )
    );
  };

  const handleAddProperty = () => {
    dispatch(
      openModal({
        title: `Ajouter une propriété`,
        content: <AddProperty />,
      })
    );
  };
  const handleAddProgramme = () => {
    dispatch(
      openModal({
        title: `Ajouter un programme`,
        content: <AddProgramme />,
      })
    );
  };

  return loading ? (
    <div></div>
  ) : (
    <div>
      <ImmoHeader
        ongletType={ongletType}
        activeView={activeView}
        setActiveView={(view) => dispatch(setActiveView(view))}
        deepSearch={true}
        filterInput={filterInput}
        setFilterInput={setFilterInput}
        changedOnglet={changedOnglet}
        // handleSearch={handleSearch}
      />

      {activeView === "lots" ? (
        <>
          <div className="mt-20">
            <button
              onClick={handleAddProperty}
              className="radius5 px-20 py-10 bg-pink text-white border-0 hoverOpacity"
            >
              Ajouter un Lot
            </button>
          </div>
          <ListeLots
            lots={listesLots}
            loading={lotsLoading}
            error={lotsError}
            filterInput={filterInput}
            ongletType={ongletType}
            ongletId={ongletId}
            query={query}
            sortConfig={sortConfigLots}
            setSortConfig={setSortConfigLots}
          />
          <Pagination
            currentPage={lotsPagination.page}
            totalPages={lotsPagination.pageCount}
            onPageChange={handleLotsPageChange}
            className="mt-20"
          />
        </>
      ) : null}
      {activeView === "programmes" ? (
        <>
          <div className="mt-20">
            <button
              onClick={handleAddProgramme}
              className="radius5 px-20 py-10 bg-pink text-white border-0 hoverOpacity"
            >
              Ajouter un Programme
            </button>
          </div>
          <ListeProgrammes
            listeDesProgrammes={listeDesProgrammes}
            filterInput={filterInput}
            ongletType={ongletType}
            ongletId={ongletId}
            query={query}
            sortConfig={sortConfigProgrammes}
            setSortConfig={setSortConfigProgrammes}
          />
          <Pagination
            currentPage={programmesPagination.page}
            totalPages={programmesPagination.pageCount}
            onPageChange={handleProgramPageChange}
            className="mt-20"
          />
        </>
      ) : null}
      {activeView === "carte" ? (
        <>
          <ListeCarte
            listeDesProgrammes={listeDesProgrammes}
            programmeListMap={programmeListMap}
            programmesCoordinates={programmesCoordinates}
            filterInput={filterInput}
            ongletType={ongletType}
            ongletId={ongletId}
            query={query}
            ongletName={ongletName}
          />
          <Pagination
            currentPage={programmeListMapPagination.page}
            totalPages={programmeListMapPagination.pageCount}
            onPageChange={handleProgramPageChange}
            className="mt-20"
          />
        </>
      ) : null}
    </div>
  );
};

export default Stock;
